import { useEffect, useState } from 'react';

export const useEmphasizeCard = (isSupposedToEmphasize: boolean, cardHasBeenClicked: boolean) => {
    const [emphasizeCard, setEmphasizeCard] = useState(false);

    if (!isSupposedToEmphasize) {
        return false;
    }

    useEffect(() => {
        setEmphasizeCard(!cardHasBeenClicked);
    }, [cardHasBeenClicked]);

    return emphasizeCard;
};
